<template>
  <div class="wrapping">
    <div class="item-title">
      <p v-if="props.translate">お取引に関するご案内</p>
      <p v-else>Notice Regarding Transactions</p>
    </div>
    <div v-if="props.translate" class="item-detail">
      <p v-text="transactionsJa"></p>
    </div>
    <div v-else class="item-detail-en">
      <p v-text="transactionsEn"></p>
    </div>
  </div>
</template>
  
<script lang="ts" setup>
import { ref } from 'vue'

const props = defineProps(['translate']) 

// Notice Regarding Transactions
const transactionsEn = ref(`At this time, we are focusing on serving our existing clients. Updates about future business opportunities will be shared at a later date.`)
const transactionsJa = ref(`当面は現在お取引のあるお客様のご対応に限らせていただいております。
            状況が変わりましたら改めてお知らせいたします。`)
</script>

<style scoped>
.wrapping {
  position: absolute;
  left: 0;
  width: 100%;
  height: 35%;
  margin: 20px 0;
  background-color: #f9f9f9;
  opacity: 0.9;
}
.item-title {
  color: #f9ffff;
  font-size: 1.1rem;
  text-align: center;
  background-color: #2c3e50;
  margin-top: 15px;
  padding: 5px;
  opacity: 0.8;
}
.item-detail {
  padding: 30px;
}
.item-detail-en {
  padding: 15px;
}
.img-mtg {
  margin: 10px;
  text-align: left;
}
.img-mtg img {
  height: 100px;
}
.img-staff :hover {
  opacity: 0.5;
}
p{
  margin: 0;
}
p.ttl{
  font-weight: bold;
  margin: 20px 0 5px;
}
</style>
  